module.exports = __webpack_public_path__ + "img/SOF2020-2021annualreport.b3e52e93.jpg";